import App from './App'
import render from 'commons/js/util/render'
import { init } from 'commons/js/util/reporter'

init()

const list = document.querySelectorAll('.js-searcher')

// Thanks IE11 for not supporting forEach on NodeList
Array.prototype.forEach.call(list, (element) => {
    render({ App, element, props: { countryId: element.dataset.countryId } })
})
